/**
 * FrCarouselSlider — Fratelli Rossetti paginated carousel.
 * Mobile: 2 cards/page · Desktop (≥1024px): 4 cards/page.
 * Used by: snippets/recommendations-fr.liquid,
 *           sections/recently-viewed.liquid,
 *           sections/product-list.liquid
 */
if (!customElements.get('fr-carousel-slider')) {
  class FrCarouselSlider extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._slider = this.querySelector('.slider');
      this._grid = this.querySelector('.slider__grid');
      this._prevBtn = this.querySelector('.fr-btn-prev');
      this._nextBtn = this.querySelector('.fr-btn-next');
      this._currentPage = 0;

      if (!this._slider || !this._grid || this._grid.children.length < 2) return;

      this._measure();
      if (this._totalPages < 2) return;

      this.removeAttribute('inactive');
      this._updateButtons();

      this._prevBtn?.addEventListener('click', () => this._go(-1));
      this._nextBtn?.addEventListener('click', () => this._go(1));

      let scrollTimer;
      this._slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => this._onScroll(), 100);
      });

      const ro = new ResizeObserver(() => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          this._measure();
          this._updateButtons();
        }, 200);
      });
      ro.observe(this._slider);
    }

    _measure() {
      const slides = Array.from(this._grid.children);
      if (!slides.length) return;

      const slideWidth = slides[0].clientWidth;
      if (!slideWidth) return;

      const slideGap = slides.length > 1
        ? slides[1].offsetLeft - slides[0].offsetLeft - slideWidth
        : 0;

      this._slideSpan = slideWidth + slideGap;
      this._slidesPerPage = Math.max(1, Math.round((this._slider.clientWidth + slideGap) / this._slideSpan));
      this._totalPages = Math.ceil(slides.length / this._slidesPerPage);
      this._currentPage = Math.max(0, Math.min(this._currentPage || 0, this._totalPages - 1));
    }

    _go(dir) {
      const next = Math.max(0, Math.min(this._currentPage + dir, this._totalPages - 1));
      if (next === this._currentPage) return;
      this._currentPage = next;
      this._slider.scrollTo({
        left: this._currentPage * this._slidesPerPage * this._slideSpan,
        behavior: 'smooth',
      });
      this._updateButtons();
    }

    _onScroll() {
      if (!this._slideSpan || !this._slidesPerPage) return;
      this._currentPage = Math.round(this._slider.scrollLeft / (this._slidesPerPage * this._slideSpan));
      this._updateButtons();
    }

    _updateButtons() {
      if (this._prevBtn) this._prevBtn.disabled = this._currentPage <= 0;
      if (this._nextBtn) this._nextBtn.disabled = this._currentPage >= this._totalPages - 1;
    }
  }

  customElements.define('fr-carousel-slider', FrCarouselSlider);
}
